"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _config = require("../config");
var _GoogleTranslate = _interopRequireDefault(require("react-platform-components/dist/Translations/GoogleTranslate"));
var _lodash = _interopRequireDefault(require("lodash"));
var _helpers = require("react-platform-components/dist/helpers");
var _index = require("react-platform-components/dist/helpers/index");
var _Translations = require("react-platform-components/dist/Translations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ConversationItem = function ConversationItem(props) {
  var _item$user, _item$user2, _item$user$avatar;
  var item = props.item,
    classes = props.classes,
    isFirstMessageOfGroup = props.isFirstMessageOfGroup,
    isLastMessageOfGroup = props.isLastMessageOfGroup,
    shouldShowContactAvatar = props.shouldShowContactAvatar,
    onCounterPropositionHandle = props.onCounterPropositionHandle,
    onImagePreview = props.onImagePreview,
    onPurchaseProduct = props.onPurchaseProduct,
    user = props.user,
    shouldShowSendingTime = props.shouldShowSendingTime;
  var handleImagePreviewOpen = function handleImagePreviewOpen(attachment) {
    return function (event) {
      onImagePreview(attachment);
    };
  };
  var handleAcceptCounterProposition = function handleAcceptCounterProposition() {
    onCounterPropositionHandle(item.proposition, 'accept');
  };
  var handleRefusedCounterProposition = function handleRefusedCounterProposition() {
    onCounterPropositionHandle(item.proposition, 'refused');
  };
  var contactName = "".concat(item === null || item === void 0 ? void 0 : (_item$user = item.user) === null || _item$user === void 0 ? void 0 : _item$user.first_name, " ").concat((item === null || item === void 0 ? void 0 : (_item$user2 = item.user) === null || _item$user2 === void 0 ? void 0 : _item$user2.last_name) || "");
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.messageRow, {
      'me': item.user.id.toString() === user.id.toString()
    }, {
      'contact': item.user.id.toString() !== user.id.toString()
    }, {
      'first-of-group': isFirstMessageOfGroup
    }, {
      'last-of-group': isLastMessageOfGroup
    }),
    style: {
      marginBottom: shouldShowSendingTime && "10px"
    }
  }, shouldShowContactAvatar && /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    placement: "top",
    title: contactName
  }, (_item$user$avatar = item.user.avatar) !== null && _item$user$avatar !== void 0 && _item$user$avatar.default ? /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    className: classes.avatarInConversation,
    alt: contactName,
    src: (0, _helpers.joinPaths)(_config.BASE_URL, item.user.avatar.default)
  }) : /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    className: classes.avatarInConversation
  }, _lodash.default.toUpper(contactName[0]))), item.user.id.toString() !== user.id.toString() ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row'
    }
  }, /*#__PURE__*/_react.default.createElement(_GoogleTranslate.default, {
    text: item.body
  }, function (_ref) {
    var text = _ref.text,
      TranslateButton = _ref.TranslateButton,
      Loading = _ref.Loading;
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_defineProperty({}, classes.bubble, true))
    }, Loading ? /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginBottom: 30
      }
    }, /*#__PURE__*/_react.default.createElement(Loading, null)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, item.attachments.map(function (attachment, index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: index,
        style: {
          height: 100,
          minWidth: 100,
          width: 100,
          margin: 5,
          cursor: 'zoom-in'
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        onClick: handleImagePreviewOpen(attachment),
        style: {
          borderRadius: 2,
          width: '100%',
          height: '100%',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          objectFit: 'cover'
        },
        src: "".concat(_config.BASE_URL ? _config.BASE_URL.slice(0, -1) : null).concat(attachment.url),
        alt: "The solehouse attachment"
      }));
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.message
    }, !!item.proposition && item.proposition.status === 'refused' ? /*#__PURE__*/_react.default.createElement("del", {
      style: {
        lineHeight: '1.5'
      }
    }, text) : /*#__PURE__*/_react.default.createElement("span", {
      style: {
        lineHeight: '1.5'
      }
    }, text)))), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'flex-start',
        marginTop: 0,
        alignItems: 'center'
      }
    }, _config.USE_GOOGLE_TRANSLATE && _lodash.default.isEmpty(item.attachments) && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(TranslateButton, null)), shouldShowSendingTime && /*#__PURE__*/_react.default.createElement(_core.Typography, {
      style: {
        fontSize: 11,
        marginTop: 0,
        display: 'block'
      },
      color: "textSecondary"
    }, (0, _index.formatDate)(item.created_at))));
  }), !!item.proposition && item.proposition.status === 'waiting' && /*#__PURE__*/_react.default.createElement("div", null, _config.HANDLE_PROPOSITION_DESIGN ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.Chip, {
    style: {
      marginLeft: 5,
      height: 40,
      width: 120
    },
    className: classes.handlePropositionColor,
    onClick: handleRefusedCounterProposition,
    icon: /*#__PURE__*/_react.default.createElement(_core.Icon, {
      className: "text-18",
      color: "action",
      style: {
        color: "rgba(229,57,53,1)"
      }
    }, "cancel"),
    label: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Refuser"
    })
  }), /*#__PURE__*/_react.default.createElement(_core.Chip, {
    style: {
      marginLeft: 5,
      height: 40,
      width: 120
    },
    className: classes.handlePropositionColor,
    onClick: handleAcceptCounterProposition,
    icon: /*#__PURE__*/_react.default.createElement(_core.Icon, {
      className: "text-18",
      color: "action",
      style: {
        color: "rgba(76,175,80,1)"
      }
    }, "check_circle"),
    label: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Accepter"
    })
  })) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    placement: "top",
    title: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "R\xE9fuser l'offre"
    })
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: handleRefusedCounterProposition,
    style: {
      marginLeft: 5,
      height: 40,
      width: 40
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    className: "text-18",
    color: "action",
    style: {
      color: 'rgba(229,57,53,1)'
    }
  }, "cancel"))), /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    placement: "top",
    title: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Accepter l'offre"
    })
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: handleAcceptCounterProposition,
    style: {
      height: 40,
      width: 40
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    className: "text-18",
    color: "action",
    style: {
      color: 'rgba(76,175,80,1)'
    }
  }, "check_circle"))))), item.subject === 'accept_proposition' && /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    placement: "top",
    title: "Acheter maintenant"
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: onPurchaseProduct,
    className: classes.IconButton
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    className: "text-18",
    color: "action"
  }, "add_shopping_cart")))) : /*#__PURE__*/_react.default.createElement("div", {
    className: classes.bubble
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.message
  }, !!item.proposition && item.proposition.status === 'refused' ? /*#__PURE__*/_react.default.createElement("del", {
    style: {
      lineHeight: '1.5'
    }
  }, item.body) : /*#__PURE__*/_react.default.createElement("span", {
    style: {
      lineHeight: '1.5'
    }
  }, item.body)), item.attachments.map(function (attachment, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      style: {
        height: 100,
        minWidth: 100,
        width: 100,
        margin: 5,
        cursor: 'zoom-in'
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      onClick: handleImagePreviewOpen(attachment),
      style: {
        borderRadius: 2,
        width: '100%',
        height: '100%',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        objectFit: 'cover'
      },
      src: "".concat(_config.BASE_URL ? _config.BASE_URL.slice(0, -1) : null).concat(attachment.url),
      alt: "The solehouse attachment"
    }));
  }), shouldShowSendingTime && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.time,
    color: "textSecondary"
  }, (0, _index.formatDate)(item.created_at))));
};
var _default = ConversationItem;
exports.default = _default;